import type { AgentOrbState } from "@productlane/ui/src/components/agent-orb/agent-orb"
import { AgentOrb } from "@productlane/ui/src/components/agent-orb/agent-orb"

export function AgentMessageAvatar({ state }: { state?: AgentOrbState }) {
	return <AgentOrb size={24} state={state} />
}
